import React from "react";
import styles from "./FullProfile.module.css";

export default function Achievements({ data }) {
  return (
    <>
      <h4>Achievements </h4>
      <div className={styles.noGrid}>
        {data?.achievements?.length
          ? data?.achievements.map((item) => (
              <div key={item.title} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.title}</div>
                <div className={styles.publishRow}>
                  <strong>Type of Achievement : </strong> {item.type_of_achievement}
                </div>
                <div className={styles.publishRow}>
                  <strong>Awarding : </strong> {item.awarding}
                </div>
                <div className={styles.publishRow}>
                  <strong>Recognizing Body : </strong> {item.recognizing_body}
                </div>
                <div className={styles.publishRow}>
                  <strong>Description : </strong> {item.description}
                </div>
                <div className={styles.publishRow}>
                  <strong>year : </strong> {item.year}
                </div>
              </div>
            ))
          : "No Records"}
      </div>
      
    </>
  );
}
